module.exports = {"title":"Alle Informationen"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/print.json
// module id = i0uh
// module chunks = 1